export { default as getRegions } from './getRegions';

export type { GetRegionsFunction, GetRegionsPayload, Region } from './getRegions.type';
